var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slides", class: _vm.sliderClass },
    [
      _c(
        "swiper",
        {
          ref: "swiper",
          staticClass: "slides__list",
          attrs: { options: _vm.swiperOptions }
        },
        [_vm._t("default")],
        2
      ),
      _vm._t("pagination", null, { slot: "pagination" }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasNext,
              expression: "hasNext"
            }
          ],
          staticClass: "slides__next",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.slideNext($event)
            }
          }
        },
        [_vm._t("button-next")],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPrev,
              expression: "hasPrev"
            }
          ],
          staticClass: "slides__prev",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.slidePrev($event)
            }
          }
        },
        [_vm._t("button-prev")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d46acd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d46acd3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/slider/slider.vue
// module id = 171
// module chunks = 4